import React, { useState } from "react";
import styled from "styled-components";
import { SearchIcon } from "../assets/svg/SearchIcon";

interface IProps {
  handleChange?: any;
}

const SearchInput = ({ handleChange }: IProps) => {

  const [inputValue, setInputValue] = useState("");

  const handleClearInput = () => {
    setInputValue("");
    handleChange();
  };

  return (
    <InputContainer>
      <Icon>
        <SearchIcon />
      </Icon>
      <Input placeholder="Search" onChange={handleChange} 
      />
    </InputContainer>
  );
};

export default SearchInput;

const InputContainer = styled.div`
  display: flex;
  align-items: center; /* Center items vertically */
  justify-content: center; /* Center items horizontally */
  position: relative;
  padding: 1em;
  padding-right: 2em;
`;


const Input = styled.input`
  padding: 1em 2em;
  font-weight: 600;
  color: #214160;
  box-shadow: none;
  border: 1.5px solid rgba(76, 92, 251, 0.1);
  border-radius: 0.4em;
  background: transparent !important;
  height: 0.675em;
  width: 90%;

  ::placeholder {
    color: #01A8CE;
    opacity: 0.5;
    font-size: 0.75em;
  }
  &:focus {
    border-radius: 0.5em;
    box-shadow: none;
    outline: none;
  }
`;

const Icon = styled.span`
  position: absolute;
  left: 1.2em; /* Adjust the left position as needed */
  top: 50%; /* Center vertically */
  transform: translateY(-50%); /* Adjust to center vertically */
`;
